import { getAll} from "../../fetchs/get";
import { sessionEnd } from "../../redux/actions";

export default async function getBossSalary (
    forecastId : string | undefined,
    forecastVersion: number | undefined,
    setBossSalary : Function,
    token : string | undefined,
    dispatch : Function,
    setError : Function
) {
    if(token){
        getAll(token, '/forecast/'+forecastId+"/"+forecastVersion+'/bossSalary', setBossSalary, 
            () => {
                dispatch(sessionEnd());
            }, setError
        )
    }
}